import React from 'react';
import { Button, Select } from '@/ui/components';

type ListPaginationControlsProps = {
  page: number;
  pageSize: number;
  totalPages: number;
  totalRecords: number;
  currentCount: number;
  pageSizeOptions?: number[];
  onPageChange: (page: number) => void;
  onPageSizeChange: (pageSize: number) => void;
};

const DEFAULT_PAGE_SIZE_OPTIONS = [20, 50, 100];

const ListPaginationControls: React.FC<ListPaginationControlsProps> = ({
  page,
  pageSize,
  totalPages,
  totalRecords,
  currentCount,
  pageSizeOptions = DEFAULT_PAGE_SIZE_OPTIONS,
  onPageChange,
  onPageSizeChange,
}) => {
  const safePage = Math.max(page, 1);
  const safeTotalPages = Math.max(totalPages, 1);
  const startRecord = totalRecords > 0 ? ((safePage - 1) * pageSize) + 1 : 0;
  const endRecord = totalRecords > 0 ? Math.min(startRecord + Math.max(currentCount, 0) - 1, totalRecords) : 0;

  return (
    <div className="dgf-list-summary" style={{ display: 'flex', gap: 12, justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap' }}>
      <div>
        {totalRecords > 0
          ? `Showing ${startRecord}-${endRecord} of ${totalRecords} records`
          : 'No records found'}
      </div>
      <div style={{ display: 'flex', gap: 10, alignItems: 'center', flexWrap: 'wrap' }}>
        <div style={{ minWidth: 120 }}>
          <Select
            value={String(pageSize)}
            density="compact"
            fullWidth
            onChange={(event) => onPageSizeChange(Number(event.target.value || pageSize))}
            options={pageSizeOptions.map((option) => ({
              value: String(option),
              label: `${option} / page`,
            }))}
          />
        </div>
        <Button
          variant="secondary"
          shape="pill"
          disabled={safePage <= 1}
          onClick={() => onPageChange(safePage - 1)}
        >
          Previous
        </Button>
        <span className="dgf-meta-muted">{`Page ${safePage} of ${safeTotalPages}`}</span>
        <Button
          variant="secondary"
          shape="pill"
          disabled={safePage >= safeTotalPages}
          onClick={() => onPageChange(safePage + 1)}
        >
          Next
        </Button>
      </div>
    </div>
  );
};

export default ListPaginationControls;
